import * as React from 'react';
import { CartProduct, Product } from '../models/interfaces';
import Cart from './Cart';

interface OrderFormCartProps {
  cartProducts: Array<CartProduct>;
  addProduct: (product: Product, amount: number) => void;
  subtractProduct: (product: Product, amount: number) => void;
  removeProduct: (product: Product) => void;
  changeProductQuantity: (product: Product, quantity: number) => void;
}

const OrderFormCart = (props: OrderFormCartProps) => {
  const {
    cartProducts,
    addProduct,
    subtractProduct,
    removeProduct,
    changeProductQuantity } = props;

  return (
    <div className="box">
      <div className="box__title"><h2>Tilauksen tiedot</h2></div>
      <div className="box__content">
        <Cart
          products={cartProducts}
          addProduct={addProduct}
          subtractProduct={subtractProduct}
          removeProduct={removeProduct}
          changeProductQuantity={changeProductQuantity}
        />
      </div>
    </div>
  );
};

export default OrderFormCart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OrderFormCart.tsx